import { render, staticRenderFns } from "./modalDefault.vue?vue&type=template&id=0c530896&scoped=true&"
import script from "./modalDefault.vue?vue&type=script&lang=js&"
export * from "./modalDefault.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=0c530896&scoped=true&lang=css&"
import style1 from "./modalDefault.vue?vue&type=style&index=1&id=0c530896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c530896",
  null
  
)

export default component.exports